import { useCallback, useState } from "react";
import { openSnapNativeCameraLab } from "../plugins/NativeFilterLab";
import "./SnapNativeCameraLabTestButton.css";

export default function SnapNativeCameraLabTestButton() {
  const [busy, setBusy] = useState(false);

  const handleOpenSnapNativeCameraLab = useCallback(async () => {
    if (busy) {
      return;
    }

    setBusy(true);
    try {
      const result = await openSnapNativeCameraLab();
      console.log("[snapNativeCameraLabTest] result", result);
    } catch (error) {
      console.log("[snapNativeCameraLabTest] error", String(error?.message || error));
    } finally {
      setBusy(false);
    }
  }, [busy]);

  return (
    <button
      type="button"
      className="snap-native-camera-lab-test-btn"
      onClick={handleOpenSnapNativeCameraLab}
      disabled={busy}
      aria-label="Open Snap Native Camera Lab test"
    >
      Open Snap Native Lab
    </button>
  );
}
